import { ReactNode, useEffect, useState } from 'react';
import { keyframes } from '@emotion/css';
import styled from '@emotion/styled';
import { delayDefaults } from '@selfserve/react-utils';

const fading = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const StyledDelay = styled('div')(
  ({
    hidden,
    animationDuration,
  }: {
    hidden?: boolean;
    animationDuration?: number;
  }) => ({
    visibility: 'hidden',
    ...(!hidden && {
      visibility: 'visible',
      animation: `${fading} linear`,
      animationDuration: `${animationDuration}s`,
    }),
  })
);

interface DelayProps {
  delay?: number;
  animationDuration?: number;
  children: ReactNode;
}

export const Delay = ({ delay, animationDuration, children }: DelayProps) => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    const delayTimeout = delay && delay > 0 ? delay : delayDefaults.DELAY;
    const timeout = setTimeout(() => setHidden(false), delayTimeout);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <StyledDelay
      hidden={hidden}
      animationDuration={animationDuration || delayDefaults.ANIMATION_DURATION}
    >
      {children}
    </StyledDelay>
  );
};
